/* @ngInject */
function AccountManagementController ($rootScope, $scope, $translate) {
  const ACCOUNT_MANAGEMENT_PAGE_SLUG = 'ACCOUNT_MANAGEMENT_PAGE'

  $scope.flags = {
    isLegacyPlan: false
  }
  $scope.pageTitle = ''

  const api = {
    _successGetCompanyWithBillingPackage
  }

  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getCompanyWithBillingPackage()
      .then(api._successGetCompanyWithBillingPackage)
  }

  $translate.onReady(() => {
    const page = $translate.instant('page')
    const of = $translate.instant('of')
    const accountManagement = $translate.instant('accountManagement')

    const featureName = `${page} ${of} ${accountManagement}`

    $scope.cardCompanyPlansData = {
      featureSlug: ACCOUNT_MANAGEMENT_PAGE_SLUG,
      featureName
    }

    $scope.pageTitle = $translate.instant('accountManagement')
  })

  function _successGetCompanyWithBillingPackage ({ billingPackage }) {
    const isNotNewPlan = (
      billingPackage.plan.id !== 1 &&
      billingPackage.plan.id !== 2 &&
      billingPackage.plan.id !== 3
    )

    if (isNotNewPlan) {
      $scope.flags.isLegacyPlan = true
    }
  }
}

export { AccountManagementController }
